import React, { useState } from "react";
import { Container, Button, Card } from "react-bootstrap";
import NavbarComp from "../../shared/components/Navbar";
import { IoAddCircleOutline } from "react-icons/io5";
import AlertMessage from "../../shared/components/Alert";
import { useCareer } from "./hooks/useCareer";
import CareerTable from "./components/CareerTable";
import PaginationControls from "./components/PaginationControls";
import SearchAndFilter from "./components/SearchAndFilter";
import SortControls from "./components/SortControls";
import CareerModal from "./components/CareerModal";
import CareerViewModal from "./components/CareerViewModal";

const CareerPage = () => {
  const {
    careers,
    loading,
    error,
    alert,
    pagination,
    meta,
    filters,
    updateEmploymentTypeFilter,
    updateStatusFilter,
    clearFilters,
    addCareer,
    editCareer,
    removeCareer, // Dari hook baru
    goToPage,
    changeLimit,
    changeSort,
    search,
    hasNextPage,
    hasPreviousPage,
    nextPage,
    previousPage,
    currentSortField,
    currentSortOrder,
  } = useCareer();

  const [showModal, setShowModal] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [viewingData, setViewingData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleOpenModal = (data = null) => {
    setEditingData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingData(null);
  };

  // Logic Submit untuk Create & Update (Sama seperti Artikel)
  const handleSubmitCareer = async (formData) => {
    let result;
    if (editingData) {
      result = await editCareer(editingData.id, formData);
    } else {
      result = await addCareer(formData);
    }

    if (result && result.success) {
      handleCloseModal();
    }
  };

  const handleDeleteCareer = (id) => {
    removeCareer(id);
  };

  return (
    <>
      <NavbarComp />
      <Container fluid className="py-4">
        <AlertMessage alert={alert} />
        <Card className="border-0 shadow-sm">
          <Card.Body className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-0">Manajemen Lowongan Kerja</h4>
              <Button variant="primary" onClick={() => handleOpenModal()}>
                <IoAddCircleOutline size={20} className="me-2" />
                Tambah Lowongan
              </Button>
            </div>

            <SearchAndFilter
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onSearchSubmit={search}
              selectedType={filters.employment_type}
              selectedStatus={filters.status}
              onTypeChange={updateEmploymentTypeFilter}
              onStatusChange={updateStatusFilter}
              onClearFilters={clearFilters}
            />

            <SortControls
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSortChange={changeSort}
            />

            <CareerTable
              careers={careers}
              loading={loading}
              error={error}
              onView={(data) => {
                setViewingData(data);
                setShowViewModal(true);
              }}
              onEdit={handleOpenModal}
              onDelete={handleDeleteCareer} // Dihubungkan ke fungsi delete
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSort={changeSort}
            />

            {!loading && careers.length > 0 && (
              <PaginationControls
                pagination={pagination}
                meta={meta}
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                onPageChange={goToPage}
                onLimitChange={changeLimit}
                onNextPage={nextPage}
                onPreviousPage={previousPage}
              />
            )}
          </Card.Body>
        </Card>
      </Container>

      <CareerModal
        show={showModal}
        handleClose={handleCloseModal}
        initialData={editingData}
        onSubmit={handleSubmitCareer} // Menangani simpan/update
      />

      {viewingData && (
        <CareerViewModal
          show={showViewModal}
          onClose={() => setShowViewModal(false)}
          career={viewingData}
        />
      )}
    </>
  );
};

export default CareerPage;
